<template>
  <v-container grid-list-lg pa-0 ma-0 fluid>
    <loading v-if="!isLoaded" />
    <v-layout row wrap v-else>
      <v-flex xs4 task__chat-files pr-4>
        <v-layout row wrap align-center>
          <v-flex grow>
            <h3>{{ $t("components.bids.chat.titleFiles") }}</h3>
          </v-flex>
          <v-flex shrink pr-0>
            <v-btn
              @click="downloadZip"
              class="task__chat-files-download ma-0 pa-0"
              text
              :disabled="isDownloadZip"
              :loading="isDownloadZip"
              v-if="historyFiles && historyFiles.length"
            >
              <v-icon color="primary" class="mr-1" size="20px">archive</v-icon
              >{{ $t("components.bids.chat.downloadAllFiles") }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          align-center
          v-for="(file, idx) in historyFiles"
          :key="`file_${idx}`"
          @click="getChatFile(file.value)"
        >
          <template v-if="file.value.mime_type">
            <v-flex shrink task__chat-file-icon>
              <span
                :class="
                  `mr-1 task__chat-file file__${getTypeName(
                    file.value.mime_type
                  )}`
                "
              ></span>
            </v-flex>
            <v-flex grow task__chat-file-name>
              {{ file.value.name }}
              <em>({{ file.value.file_size }})</em>
            </v-flex>
          </template>
          <template v-else>
            <v-flex xs12 task__chat-file-name>{{
              $t("components.bids.chat.noFile")
            }}</v-flex>
          </template>
        </v-layout>
      </v-flex>
      <v-flex xs8 pl-4>
        <v-layout row wrap>
          <v-flex
            xs12
            messages
            px-5
            pt-4
            v-if="task && history && history.length"
            id="chat"
          >
            <v-layout
              row
              wrap
              messages__item
              v-for="(item, idx) in history"
              :key="idx"
              :class="{ 'messages__item-client': item.user.role == 10 }"
            >
              <v-flex
                xs12
                sm11
                messages__item-content
                :class="{ 'messages__item--signed': item.type === 130 }"
              >
                <div class="messages__item-name" v-if="item.user">
                  <span
                    v-if="
                      item.value.bank &&
                        item.value.bank.length &&
                        item.type !== 130
                    "
                  >
                    <span class="messages__item-logo">
                      <img
                        v-if="item.value.bank_id"
                        :src="
                          require(`@/assets/images/banks/${item.value.bank_id}.jpg`)
                        "
                      />
                      <strong v-else>{{ item.value.bank[0] }}</strong>
                    </span>
                    {{ $t("components.bids.chat.username.bank") }}
                    {{ item.value.bank }}
                  </span>
                  <span v-else>
                    {{ getUserName(item) }}
                    <em>({{ getRoleTitle(item.user.role) }})</em>
                  </span>
                </div>
                <div class="messages__item-name" v-else>
                  {{ $t("components.bids.chat.username.bot") }}
                </div>

                <div class="messages__item-message">
                  <!-- <div v-if="item.type !== 6">{{ getHistoryMessage(item) }}</div> -->
                  <span class="raw_value">{{ getHistoryValue(item) }}</span>
                  <!-- <div v-if="item.message_type === 120 && item.value.link">
                                        <router-link
                                            :to="{ name: 'SignDocument', params: {hash: item.value.link} }"
                                        >Ссылка на подписание документов</router-link>
                                    </div>-->

                  <div v-if="item.message_type === 2" class="mt-3">
                    <span
                      class="messages__item-file"
                      @click="getChatFile(item.value)"
                      v-if="item.value.mime_type"
                    >
                      <span
                        :class="
                          `mr-1 task__chat-file file__${getTypeName(
                            item.value.mime_type
                          )}`
                        "
                      ></span>
                      <!-- <v-icon
                                                color="primary"
                                                class="mr-1"
                                                size="14px"
                                            >cloud_download</v-icon>-->
                      {{ item.value.name }}
                    </span>
                    <span class="messages__item-file" v-else>{{
                      $t("components.bids.chat.noFile")
                    }}</span>
                  </div>
                </div>
                <div class="messages__item-date">
                  {{ getHistoryDate(item.created_at) }}
                </div>
              </v-flex>
            </v-layout>
            <span id="chat-bottom"></span>
          </v-flex>
          <v-flex xs12 messages v-else>
            <h2 class="empty_title">
              {{ $t("components.bids.chat.titleEmptyMessages") }}
            </h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-end align-end pt-3 mt-2 messages__add>
          <v-flex grow text-left>
            <v-textarea
              v-model="message"
              :disabled="isSendBlocked"
              :placeholder="$t('components.bids.chat.messageInput')"
              hide-details
              rows="2"
              outline
              auto-grow
              class="mt-0"
            ></v-textarea>
          </v-flex>
          <v-flex shrink text-left>
            <!-- <v-btn
                    @click="addMessage(1)"
                    class="v-btn primary"
                    :disabled="false"
                        >Добавить сообщение</v-btn>-->
            <v-btn @click="addFile" text icon :disabled="isSendBlocked">
              <v-icon color="primary">attachment</v-icon>
            </v-btn>
            <v-btn
              @click="addMessage"
              text
              icon
              :disabled="(!message && !message.length) || isSendBlocked"
            >
              <v-icon color="primary" class="mx-3">send</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isOpenFileDialog" width="500">
      <v-layout row wrap modal>
        <v-flex xs12 modal__wrapper>
          <form
            enctype="multipart/form-data"
            novalidate
            v-if="isInitial || isSaving"
          >
            <div class="dropbox">
              <input
                type="file"
                multiple
                :disabled="isSaving"
                @change="filesChange($event.target.name, $event.target.files)"
                class="input-file"
              />
              <p
                v-if="isInitial"
                v-html="
                  $t('components.client.documents.fileDialog.moveFileHtml')
                "
              ></p>
              <p class="pt-1" v-if="isInitial">
                <v-icon color="error" class="mr-2">warning</v-icon
                >{{ $t("components.client.documents.fileDialog.warningTitle") }}
                <v-icon color="error" class="ml-2">warning</v-icon>
                <br />{{
                  $t("components.client.documents.fileDialog.warningText")
                }}
              </p>

              <p v-if="isSaving">
                {{ $t("components.client.documents.fileDialog.loading") }}
              </p>
            </div>
          </form>

          <div v-if="isError">
            <h2 v-if="isError && fileUploadError">{{ fileUploadError }}</h2>
            <p>
              <a href="javascript:void(0)" @click="reset()">{{
                $t("components.client.documents.fileDialog.again")
              }}</a>
            </p>
          </div>

          <!--SUCCESS-->
          <div v-if="isSuccess">
            <h1>
              {{ $t("components.client.documents.fileDialog.loadSuccess") }}
            </h1>
          </div>
          <!--FAILED-->
          <div v-if="isFailed">
            <h1 class="mb-3">
              {{ $t("components.client.documents.fileDialog.errorLoadTitle") }}
            </h1>
            <p>
              <a href="javascript:void(0)" @click="reset()">{{
                $t("components.client.documents.fileDialog.again")
              }}</a>
            </p>
            <div v-for="(error, idx) in uploadError" :key="`error_${idx}`">
              {{ error }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import moment from "moment";
import roles from "@/utils/data/roles";
import statusNames from "@/utils/data/statuses";
import formatPrice from "@/mixins/filters/formatPrice";
import i18n from "@/services/i18n";

import { uploadTaskFile } from "@/components/lib/file-upload.service";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3,
  STATUS_ERROR = 4;

const OWNER_TYPE_TASK = 1;

export default {
  name: "TaskChat",
  mixins: [formatPrice],
  data: () => ({
    isLoaded: false,
    isSendBlocked: false,
    message: "",
    history: null,
    uploadedFiles: {},
    uploadError: null,
    currentStatus: null,
    isOpenFileDialog: false,
    bankId: null,
    fileUploadError: null,
    isDownloadZip: false,
    statusNames,
  }),
  computed: {
    ...mapState({
      userId: (state) => state.user.profile.id,
      wSocket: (state) => state.wSocket.message,
    }),
    historyFiles() {
      if (!this.history) return [];
      return this.history.filter((message) => message.message_type === 2);
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    isError() {
      return this.currentStatus === STATUS_ERROR;
    },
  },
  watch: {
    wSocket(message) {
      this.getSocketMessage(message);
    },
  },
  props: {
    task: {
      type: Object,
    },
  },
  methods: {
    async getChatMessages() {
      await apiCallTrue({
        url: `v1/comments/${OWNER_TYPE_TASK}/${this.task.id}`,
      })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.result &&
            response.data.data
          ) {
            this.history = response.data.data;
          } else {
            this.history = [];
          }
          this.isLoaded = true;
          const bottom = document.getElementById("chat-bottom");
          if (bottom) {
            setTimeout(() => {
              bottom.scrollIntoView({
                behavior: "smooth",
                block: "end",
              });
            }, 20);
          }
        })
        .catch((error) => console.log(error, "get chat error"));
    },
    getUserName(item) {
      const name = item.user.full_name;
      const id = item.user.id;
      if (!name || !id) return "";
      return id === this.userId
        ? i18n.t("components.bids.chat.username.selfMessage")
        : name;
    },
    getRoleTitle(role) {
      const title = roles.filter((item) => item.id === role);
      return title.length
        ? title[0].name
        : i18n.t("components.bids.chat.username.anonim");
    },
    getHistoryDate(date) {
      moment.locale(i18n.locale);
      const now = new Date().toISOString().substr(0, 19);
      return moment(date).from(now);
      // return moment(date).fromNow();
    },
    getHistoryMessage(item) {
      if (!item) return "";

      const types = {
        1: "", //Простой текст
        2: i18n.t("components.bids.chat.historyValue.types.2"),
        3: i18n.t("components.bids.chat.historyValue.types.3"),
        4: i18n.t("components.bids.chat.historyValue.types.4"),
        5: i18n.t("components.bids.chat.historyValue.types.5", { id: item.id }),
        6: i18n.t("components.bids.chat.historyValue.types.6"),
        7: i18n.t("components.bids.chat.historyValue.types.7", {
          value: item.value,
        }),
      };
      return types[item.type];
    },
    getHistoryValue(item) {
      if (!item) return "";

      let output = null;
      const comment =
        item.value && item.value.comment
          ? i18n.t("components.bids.chat.historyValue.comment", {
              comment: item.value.comment,
            })
          : "";

      switch (item.type) {
        case 100:
          output = item.value && item.value.text ? item.value.text : item.value;
          break;
        case 110:
          output = "";
          break;
        case 120:
          if (item.value.status === 50) {
            output = i18n.t("components.bids.chat.historyValue.12050", {
              message: item.value.bank + comment,
            });
          } else if (item.value.status === 40) {
            output = i18n.t("components.bids.chat.historyValue.12050", {
              message: item.value.bank + comment,
            });
          } else {
            output = item.value.text;
          }
          break;
        case 130:
          // return `${item.value.text} для ${item.value.bank}`;
          output = item.value.text;
          break;
        default:
          output = item.value.text;
      }
      return output;
    },
    getSignLink(item) {
      if (item.type !== 130) return;
    },
    getStatusName(id, key) {
      return this.statusNames[key][id].name
        ? this.statusNames[key][id].name
        : "";
    },
    addMessage() {
      this.isSendBlocked = true;
      const method = "POST";
      const data = {
        value: this.message,
        message_type: 1,
        owner_type: 1,
        owner_id: this.task.id,
      };
      apiCallTrue({
        url: `v1/comments`,
        method,
        data,
      })
        .then((response) => {
          if (response.data && response.data.data) {
            this.message = "";
            this.isSendBlocked = false;
            // this.history.push(response.data.data);
            // this.showNotify("add");
          }
        })
        .catch((error) => console.log(error, "get chat error"));
    },
    addFile() {
      this.isOpenFileDialog = true;
    },
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData) {
      this.currentStatus = STATUS_SAVING;

      uploadTaskFile(formData, this.task)
        .then((response) => {
          console.log(response, "dfdfdfdfd");
          if (response && response.result) {
            this.currentStatus = STATUS_SUCCESS;
            setTimeout(() => (this.isOpenFileDialog = false), 2000);
            setTimeout(() => this.reset(), 3000);
          } else {
            this.currentStatus = STATUS_ERROR;
            this.fileUploadError = response.message;
          }
        })
        .catch((error) => {
          this.fileUploadError = error.message;
          this.uploadError = error.response.data.validation;
          this.currentStatus = STATUS_FAILED;
        });
    },
    filesChange(fieldName, fileList) {
      if (!fileList.length) return;

      const formData = new FormData();
      formData.append("message_type", 2);
      formData.append("owner_id", this.task.id);
      formData.append("owner_type", 1);
      formData.append("file", fileList[0]);

      this.save(formData);
    },
    openBidPackage() {
      return (this.isPackageShow = true);
    },
    openBankItems() {
      this.isBankItemsOpen = true;
    },
    closeModal() {
      this.isBankItemsOpen = false;
    },
    openFileDialog(id) {
      this.bankId = id;
      this.isOpenFileDialog = true;
    },
    async getChatFile(file) {
      await apiCallTrue({
        url: `v1/files/storage-link/${file.hash_id}`,
      }).then((response) => {
        const link = document.createElement("a");
        link.href = response.data.data;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
      });
    },
    async downloadZip() {
      this.isDownloadZip = true;
      await apiCallTrue({
        url: `v1/comments/${OWNER_TYPE_TASK}/${this.task.id}/file-compress`,
      }).then((response) => {
        this.isDownloadZip = false;
        const link = document.createElement("a");
        link.href = response.data.data;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
      });
    },
    getTypeName(mime) {
      if (!mime) return "";
      const mimeArray = mime.split("/");
      const mimeTypeArray = mimeArray[1].split(".");
      if (mimeTypeArray.length > 3) {
        // ms word fix
        return mimeTypeArray[2];
      } else if (mimeTypeArray.length > 1) {
        // ms excel fix
        return mimeTypeArray[1];
      }

      return mimeArray[1];
    },
    getSocketMessage(message) {
      let data = null;
      switch (message.type) {
        case 2:
          if (message.data) {
            data = JSON.parse(message.data);
          } else {
            break;
          }

          if (
            data.owner === this.task.id &&
            data.type === 1 &&
            message.action === "updateComment"
          ) {
            this.getChatMessages();
          }
          break;
      }
    },
  },
  mounted() {
    this.reset();
    setTimeout(() => this.getChatMessages(), 1000);
  },
};
</script>
<style lang="scss">
.messages {
  // border-top: 1px solid #dadada;
  max-height: 500px;
  overflow: auto;

  &__item {
    margin-bottom: 16px !important;

    &--signed {
      background: #404ce6 !important;
      color: #fff;

      &::before {
        border-right-color: #404ce6 !important;
      }
      .messages__item-date,
      .messages__item-name em {
        color: #fff;
        opacity: 0.4;
      }
    }

    &-content {
      background: #f7f7f7;
      border-radius: 5px;
      position: relative;
      z-index: 1;
      font-size: 14px;
      transition: all 0.3s ease;
      box-shadow: 0 0 0 #fff;

      &::before {
        content: "";
        position: absolute;
        height: 0;
        width: 0;
        left: -20px;
        bottom: 4px;
        transform: rotate(75deg);
        border: 17px solid transparent;
        border-right: 30px solid #f7f7f7;
        z-index: -1;
      }
    }

    &-client {
      justify-content: flex-end;

      .messages__item-content {
        background: #eaebf0;
        margin-right: 3px;

        &::before {
          left: auto;
          right: -15px;
          transform: rotate(105deg);
          border-right-color: #eaebf0;
        }
      }
    }

    &-status-0 {
      box-shadow: 0 0 10px #aaa;
    }

    &-name {
      font-weight: 700;
      font-size: 0.9em;

      em {
        font-weight: normal;
        color: #666;
        font-size: 0.9em;
      }
    }

    &-message {
      .raw_value {
        white-space: pre-wrap;
      }
    }

    &-date {
      text-align: right;
      font-style: italic;
      color: #666;
      font-size: 0.8em;
    }

    &-recall {
      font-size: 14px;
      color: #4caf50;
      // text-decoration: underline;
      font-style: italic;
      cursor: pointer;
    }

    &-logo {
      box-sizing: content-box;
      height: 16px;
      width: 16px;
      line-height: 14px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      margin: -4px 2px 0 0;
      background: #eee;
      border: 1px solid #dadada;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 16px;
        height: 16px;
      }
      strong {
        font-size: 9px;
        line-height: 1;
        color: #666;
      }
    }
  }
  &__add {
    border-top: 1px solid #eee;
  }
}
.v-textarea.v-text-field--enclosed textarea {
  margin-top: 0;
}

.task {
  &__chat {
    &-files {
      border-right: 1px solid #dadada;
      &-download {
        .v-btn__content {
          font-weight: 400 !important;
          font-style: italic;
          color: #404ce6;
          padding: 0 !important;
        }
      }
    }

    &-file {
      display: inline-block;
      vertical-align: top;
      height: 25px;
      width: 25px;
      // background: url(../../assets/icons/default.svg) no-repeat center top;

      &-icon {
        padding-right: 0 !important;
        max-width: 33px;
      }

      &-name {
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        // word-break: break-all;
        overflow-wrap: break-word;
        max-width: calc(100% - 33px);

        em {
          font-weight: 300;
          color: #aaa;
          font-style: italic;
        }
      }
    }
  }
}
#chat-bottom {
  position: relative;
  top: 300px;
}
.messages {
  &__item {
    &-file {
      color: #404ce6;
      font-size: 12px;
      font-weight: 700;
      font-style: italic;
      cursor: pointer;
    }
  }
}
</style>
